import React, { useState, useEffect } from 'react';
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { TextField, Typography, Button, Box, Card, Grid, TableBody, Chip } from "@mui/material";
import * as Yup from "yup";
import Divider from "@mui/material/Divider";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";
import _ from "lodash";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import "../../Myaccount/Myaccount.css";
import Checkbox from "@mui/material/Checkbox";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import axios from "../../../utils/fvAxios";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import moment from "moment";
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';


export default function EvaluationsDataEntry(props) {

    const { t } = useTranslation();

    const validationSchema = Yup.object().shape({
        firstName: Yup.string()
            .required("FirstName is required !")
            .max(20, "First name must not exceed 20 characters"),
        lastName: Yup.string()
            .required("LastName is required !")
            .min(6, "LastName must be at least 6 characters")
            .max(20, "Last name must not exceed 20 characters"),
        title: Yup.string()
            .required("Title is required !")
            .min(6, "Title must be at least 6 characters")
            .max(20, "Title must not exceed 20 characters"),
        phoneNumber: Yup.string()
            .required("Phone number is required !")
            .matches(/^\(\d{3}\) \d{3}-\d{4}$/, "format like (000) 000-0000"),
        mobileNumber: Yup.string()
            .required("Mobile number is required !")
            .typeError("Mobile number is required !")
            .matches(/^\(\d{3}\) \d{3}-\d{4}$/, "format like (000) 000-0000"),
        email: Yup.string()
            .required("Email address is required !")
            .email("Email address is invalid"),
        additionalDescription: Yup.string()
            .required("Additiona iInformation is required !")
            .typeError("Additiona iInformation is required !")
            .min(10, "Additional information must be at least 10 characters"),
    });
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema),
    });
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: 250,
            },
        },
    };

    const navigate = useNavigate();
    const [vendorReviewInput, setVendorReviewInput] = useState({});

    // const [evalutedVendors, setEvalutedVendors] = useState([]);
    const [vendorReviewInputRadio, setVendorReviewInputradio] = useState([]);
    const [ChangeVendorReviewInputRadio, setChangeVendorReviewInputradio] = useState([]);
    const [vendorReviewInputSection, setVendorReviewInputSection] = useState([]);
    const [ChangevendorReviewInputSection, setChangeVendorReviewInputSection] = useState([]);



    useEffect(() => {
        VendorReviewInput();
    }, []);

    const params = new URLSearchParams(window.location.search);
    const PQID = params.get("pqid");

    async function VendorReviewInput() {
        const res = await axios.get("/Prequalification/GetVendorReviewInput?pqId=" + PQID);
        setVendorReviewInput(res?.data?.data);
        setVendorReviewInputradio(res?.data?.data?.vendorReviews);
        setVendorReviewInputSection(res?.data?.data?.localVendorReviewSection)
        console.log(res?.data?.data);
        
    }
    // async function Organization() {
    //     const res = await axios.get("/Organization/GetOrganizationUsers?orgId=" + props?.PQCLIENTID);
    //     setEvalutedVendors(res?.data?.data);
    // }

    const [ReviewType, setReviewType] = useState('1');
    const [ReviewType1, setReviewType1] = useState('0');

    const [EvaluatedById, setEvaluatedById] = useState('');
    const [EvaluatedByName, setEvaluatedByName] = useState('');
    const [ProjectLocation, setProjectLocation] = useState('');
    const [Contractor, setContractor] = useState('');
    const [ReviewDate, setReviewDate] = useState('');

    const [EvaluatedByError, setEvaluatedByError] = useState('');
    const [ReviewDateError, setReviewDateError] = useState('');
    const [ContractorError, setContractorError] = useState('');
    const [ProjectLocationError, setProjectLocationError] = useState('');

    const ChangeDate = (e) => {
        setReviewDate(e);
    }

    const ChangeEvaluatedBy = (e) => {
        setEvaluatedById(e)
        const EvalutionvendorName = props?.evalutedVendors?.find((r) => r?.userId == e);
        setEvaluatedByName(EvalutionvendorName?.fullName);
    }
    const ProjectLocationHandle = (e) => {
        let empty = /[^ ]/;
        if (e?.target?.value != "" && empty?.test(e?.target?.value)) {
            setProjectLocationError("");
            setProjectLocation(e?.target?.value)
        } else {
            setProjectLocationError("Please enter field");
            setProjectLocation(e?.target?.value)
        }
    }
    const ContractorHandle = (e) => {
        let empty = /[^ ]/;
        if (e?.target?.value != "" && empty?.test(e?.target?.value)) {
            setContractorError("");
            setContractor(e?.target?.value);
        } else {
            setContractorError("Please enter field ");
            setContractor(e?.target?.value);
        }
    }

    const ChangeRating = (r, val) => {
        const data = _.cloneDeep(vendorReviewInputRadio);
        var info = data?.find(x => x?.vendorReviewQuestionId == r?.vendorReviewQuestionId);
        if (info)
            info.rating = val;
        setVendorReviewInputradio(data);
        setChangeVendorReviewInputradio(data);

    };

    const ChangeQuestions = (r, val) => {
        const data = _.cloneDeep(vendorReviewInputSection);
        var info = data?.find(x => x?.id == r?.id);
        if (info)
            info.answers = val;
        setVendorReviewInputSection(data);
        setChangeVendorReviewInputSection(data);

    };
    const [spinner, setSpinner] = React.useState(false);
    const SpinnerClose = () => {
        setSpinner(false);
    };

    const SaveRating = async () => {
        setSpinner(true);
        const localVendorReviewSection = ChangevendorReviewInputSection?.map((r) => {
            return {
                "id": r?.id,
                "sectionHeader": r?.sectionHeader,
                "hasQuestion": r?.hasQuestion,
                "questionText": r?.questionText,
                "questionTypeID": r?.questionTypeID,
                "options": r?.options,
                "clientId": r?.clientId,
                "order": r?.order,
                "answers": r?.answers,
                "isEditable": r?.isEditable,
                "group": r?.group
            }
        })

        const VendorReviews = ChangeVendorReviewInputRadio?.map((r) => {
            return {
                "vendorReviewQuestionId": r?.vendorReviewQuestionId,
                "questionString": r?.questionString,
                "rating": r?.rating,
                "qisMandatory": r?.qisMandatory
            }
        })

        const data = {
            "evaluatedBy": EvaluatedById,
            "evaluatedByDisplayName": EvaluatedByName,
            "canUserEdit": vendorReviewInput?.canUserEdit,
            "reviewType": props.RatingType == 1 ? ReviewType : ReviewType1,
            "reviewDate": ReviewDate,
            "projectLocation": props.RatingType == 1 ? ProjectLocation : null,
            "contractWONumber": props.RatingType == 1 ? Contractor : null,
            "localVendorReviewSection": localVendorReviewSection,
            "vendorReviews": VendorReviews,
            "preQualificationId": vendorReviewInput?.preQualificationId,

            "selectedVendorId": vendorReviewInput?.selectedVendorId,
            "buid": vendorReviewInput?.buid,
            "vendorReviewInputId": vendorReviewInput?.vendorReviewInputId,
            "vendorName": vendorReviewInput?.vendorName
        }

        if (props.RatingType == 1) {
            if (EvaluatedById != "" && Contractor != "" && ProjectLocation != "" && ReviewDateError == "" && ContractorError == "" && ProjectLocationError == "" && ReviewDate != "") {
                const res = await axios.post("Prequalification/SaveVendorReviewInput", data)
                if (res?.data?.responseMessage == "Success") {

                    toast.success(res?.data?.data, {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });


                    // props.Reset(!props.Refresh);
                    window.location.reload();
                    // props.RatingTypeChange((p) => !p, '');
                } else {
                    toast.error(res?.data?.responseMessage, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }
            } else {
                toast.error("Please enter mandatory fields", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });

            }
            setSpinner(false);
        } else {
            if (EvaluatedById != "" && ReviewDateError == "" && ReviewDate != "") {
                const res = await axios.post("Prequalification/SaveVendorReviewInput", data)
                if (res?.data?.responseMessage == "Success") {

                    toast.success(res?.data?.data, {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });


                    // props.Reset(!props.Refresh);
                    window.location.reload();
                    // props.RatingTypeChange((p) => !p, '');
                } else {
                    toast.error(res?.data?.responseMessage, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }
            } else {
                toast.error("Please enter mandatory fields", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
            setSpinner(false);

        }

    }


    return (
        <>
            <ToastContainer />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
                onClick={SpinnerClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Card sx={{ paddingTop: "10px" }}>
                <p className='mx-3'>Please answer the questions below, and rate this contractor on a scale of</p>
                <p className='mx-3'><Chip sx={{ backgroundColor: "black", color: "#FFFFFF", borderRadius: "3px" }} label="N/A" /> Not Applicable        <Chip sx={{ backgroundColor: "black", color: "#FFFFFF", borderRadius: "3px" }} label="1" /> Improvement Needed        <Chip sx={{ backgroundColor: "black", color: "#FFFFFF", borderRadius: "3px" }} label="2" /> Meets Requirements        <Chip sx={{ backgroundColor: "black", color: "#FFFFFF", borderRadius: "3px" }} label="3" /> Above Average</p>
                <p className='mx-3'>This result will be tabulated automatically. Average scores will be displayed in the <b>Vendor Details section</b></p>
            </Card>
            <Card className='mt-2' sx={{ paddingTop: "10px", paddingBottom: "12px" }}>
                <label className="personal-info-heading">
                    <b>{t("ProjectEvalution.Section1")}</b>
                </label>
                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "1px" }} />
                {/* first section */}
                <div className="row mt-2">
                    <div className="col-sm-5 col-md-5 col-xl-5 mt-4">
                        <span className="input-label-right">
                            {t("ProjectEvalution.Evaluatedby")}
                            <small style={{ color: "red" }}>*</small>
                        </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <FormControl fullWidth>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={EvaluatedById}
                                onChange={(e) => ChangeEvaluatedBy(e?.target?.value)}
                                size="small"
                                MenuProps={MenuProps}
                                sx={{
                                    width: "299px", "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                }}
                            >
                                {props?.evalutedVendors?.map((r, index) =>
                                    <MenuItem key={index} title={r?.fullName} value={r?.userId}>{r?.fullName}</MenuItem>
                                )}
                            </Select>
                        </FormControl>

                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 " style={{ color: "red" }}>{EvaluatedByError}</div>
                </div>
                <Divider className="mt-3" />
                {/*2nd section */}
                <div className="row mt-2">
                    <div className="col-sm-5 col-md-5 col-xl-5 mt-3">
                        <span className="input-label-right">
                            {t("ProjectEvalution.ReviewType")}

                        </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        {props?.RatingType == 1 ?
                            <FormControl>
                                <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    value={ReviewType}
                                    name="radio-buttons-group"
                                    onChange={(e) => setReviewType(e?.target?.value)}
                                >
                                    <Stack direction="row">
                                        <FormControlLabel value="1" control={<Radio />} label="Project" />
                                    </Stack>
                                </RadioGroup>
                            </FormControl>
                            :
                            <FormControl>
                                <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    value={ReviewType1}
                                    name="radio-buttons-group"
                                    onChange={(e) => setReviewType1(e?.target?.value)}
                                >
                                    <Stack direction="row">
                                        <FormControlLabel value="0" control={<Radio />} label="Annual" hidden={!vendorReviewInput?.isAnnualReviewRequired} />
                                        <FormControlLabel value="2" control={<Radio />} label="Bi-Annual" hidden={!vendorReviewInput?.isBiAnnualReviewRequired} />
                                    </Stack>
                                </RadioGroup>
                            </FormControl>

                        }
                    </div>


                    <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
                </div>
                <Divider className="mt-3" />
                {/*3rd section */}
                <div className="row mt-2">
                    <div className="col-sm-5 col-md-5 col-xl-5 mt-3">
                        <span className="input-label-right">
                            {t("ProjectEvalution.ReviewDate")}
                            <small style={{ color: "red" }}>*</small>
                        </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField type='date'
                            value={ReviewDate || ""}
                            onChange={(e) => {
                                ChangeDate(e?.target?.value);
                            }}
                            onKeyDown={(e) => e.preventDefault()}
                            size='small'
                            sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                                width: "299px"
                            }} />

                        {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={ReviewDate}
                                onChange={(event) => {
                                    setReviewDate(event?.$d)
                                    setReviewDateError(event?.$d == "" ? "Please select date" : "");
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        sx={{
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            width: "299px"
                                        }}
                                        size="small"
                                        {...params}
                                    />
                                )}
                            />
                        </LocalizationProvider> */}

                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 " style={{ color: "red" }}>{ReviewDateError}</div>
                </div>
                {props?.RatingType == 1 ? (<>
                    <Divider className="mt-3" />
                    {/*4th section */}
                    <div className="row mt-2">
                        <div className="col-sm-5 col-md-5 col-xl-5 mt-3 ">
                            <span className="input-label-right">
                                {t("ProjectEvalution.ProjectLocation")}
                                <small style={{ color: "red" }}>*</small>
                            </span>
                        </div>
                        <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                            <TextField
                                sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                    width: "300px"
                                }}

                                value={ProjectLocation}
                                placeholder={t("ProjectEvalution.ProjectLocation")}
                                size="small"
                                className="form-control text-feild-custom"
                                onChange={(e) => ProjectLocationHandle(e)}
                            />

                        </div>
                        <div className="col-sm-2 col-md-2 col-xl-2 " style={{ color: "red" }}>{ProjectLocationError}</div>
                    </div>
                    <Divider className="mt-3" />
                    {/*5th section */}
                    <div className="row mt-2">
                        <div className="col-sm-5 col-md-5 col-xl-5 mt-3">
                            <span className="input-label-right">
                                {t("ProjectEvalution.ContractororWO")}{" "}
                                <small style={{ color: "red" }}>*</small>
                            </span>
                        </div>
                        <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                            <TextField

                                sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                    width: "300px"
                                }}

                                required
                                type="text"
                                value={Contractor}
                                placeholder={t("ProjectEvalution.ContractororWO")}
                                size="small"
                                className="form-control text-feild-custom"
                                onChange={(e) => ContractorHandle(e)}
                            />

                        </div>
                        <div className="col-sm-2 col-md-2 col-xl-2 " style={{ color: "red" }}>{ContractorError}</div>
                    </div>
                </>) : ""}

            </Card>





            <Box className="mt-3">
                <TableContainer component={Paper} className="mb-3">
                    <h5 className="mx-3 my-3" variant="contained">
                        {t("ProjectEvalution.Section")}
                    </h5>

                    <span className="mx-3" style={{ color: "#667085" }}>
                        {t("ProjectEvalution.label")} <span style={{ color: "#2A93DB" }}> {t("ProjectEvalution.label1")}</span>
                    </span>
                    <Box
                        className="mx-2"
                        sx={{ width: "auto", backgroundColor: "#F9FAFB", padding: "12px" }}
                    >
                        {t("ProjectEvalution.label2")}
                    </Box>

                    <Box sx={{ padding: "20px" }}>
                        {vendorReviewInputRadio?.map((r, index) => (
                            <div key={index}>
                                <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>

                                    <Grid item xs={12} sm={4} md={4} >
                                        {r?.questionString}
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={8} >
                                        <RadioGroup
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            name="radio-buttons-group"
                                        // defaultValue={ResetRadio}
                                        >
                                            <Stack direction="row" spacing={5} >

                                                <FormControlLabel value="0" onChange={(event) => {
                                                    ChangeRating(r, event?.target?.value);
                                                }} control={<Radio />} label="Not Applicable" />

                                                <FormControlLabel value="1" onChange={(event) => {
                                                    ChangeRating(r, event?.target?.value);
                                                }} control={<Radio />} label="Improvement Needed" />

                                                <FormControlLabel value="2" onChange={(event) => {
                                                    ChangeRating(r, event?.target?.value);
                                                }} control={<Radio />} label="Meets Requirements" />

                                                <FormControlLabel value="3" onChange={(event) => {
                                                    ChangeRating(r, event?.target?.value);
                                                }} control={<Radio />} label="Above Average" />

                                            </Stack>

                                        </RadioGroup>
                                    </Grid>


                                </Grid>
                                <hr />
                            </div>
                        ))}
                    </Box>

                </TableContainer>
            </Box>







            <Card sx={{ paddingTop: "10px", paddingBottom: "12px" }}>
                <label className="personal-info-heading">
                    <b>{t("ProjectEvalution.Section3")}</b>
                </label>
                <Divider
                    sx={{
                        marginTop: 2,
                        marginBottom: 2,
                        backgroundColor: "#667085;",
                        height: "1px",
                    }}
                />
                {/* first section */}
                {vendorReviewInputSection?.map((r, index) => (
                    <div key={index}>
                        <div style={{ padding: "10px" }} hidden={!r?.sectionHeader}>
                            <Grid sx={{ padding: "12px", backgroundColor: "#F9FAFB", color: "#667085" }}>
                                {r?.sectionHeader}
                            </Grid>
                        </div>
                        <div className="row mt-2" hidden={!r?.hasQuestion}>
                            <div className="col-sm-5 col-md-5 col-xl-5 mt-4">
                                <span className="input-label-right" >{r?.questionText}</span>
                            </div>
                            <div className="col-sm-4 col-md-4 col-xl-4 mt-3 ">
                                <FormControl className="mb-5">
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        hidden={!r?.options}
                                    >
                                        <FormControlLabel
                                            value="1"
                                            onChange={(event) => {
                                                ChangeQuestions(r, event?.target?.value);
                                            }} control={<Radio />}
                                            label="yes"

                                        />
                                        <FormControlLabel
                                            value="0"
                                            onChange={(event) => {
                                                ChangeQuestions(r, event?.target?.value);
                                            }} control={<Radio />}
                                            label="no"

                                        />
                                    </RadioGroup>
                                </FormControl>
                                <TextareaAutosize
                                    maxRows={4}
                                    aria-label="maximum height"
                                    placeholder="Maximum 4 rows"
                                    color="secondary"
                                    style={{ width: "300px", height: "128px" }}
                                    onChange={(event) => {
                                        ChangeQuestions(r, event?.target?.value);
                                    }}
                                    hidden={r?.options}
                                />

                            </div>
                            <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
                        </div>

                    </div>
                ))}



                <Stack direction="row" sx={{ float: "right", marginRight: "10px" }} spacing={2}>
                    <Button variant="contained" href={"/vendordetails?pqid=" + PQID} sx={{
                        textTransform: "capitalize", padding: "15px", color: "#fff", "&:hover": {
                            color: "#fff",
                            backgroundColor: "#1565c0",
                        },
                    }}> {t("ProjectEvalution.label3")}</Button> {/*onClick={() => props.RatingTypeChange((p) => !p, '')}*/}
                    <Button variant="contained" onClick={SaveRating} sx={{ textTransform: "capitalize", padding: "15px", }}> {t("ProjectEvalution.label4")}</Button>
                </Stack>
            </Card>
        </>
    )
}
